import { Button, Input, Modal, ModalDialog } from "@mui/joy";
import React, { useEffect, useState } from "react";
import ModalHeaderForMoney from "./modalheader";
import { postFetch } from "../../../../../fetch/fetch";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import koLocale from 'date-fns/locale/ko'
import { DateRange, StaticDateRangePicker } from "@mui/x-date-pickers-pro";
import { Box, TextField } from "@mui/material";
import { calcRegisterFeeByLocation, makeGroupedFeeLines } from "../functions/newcalcregisterfuncs";
import { englishLocationToKorean, koreanLocationToEnglish } from "../../../../../data/locationFuntion";
import { Edit } from "@mui/icons-material";
import { set } from "lodash";


const AddGoodModal = (props: any) => {

    const [loading, setLoading] = useState<boolean>(false);
    const [selectedStudentsLocations, setSelectedStudentsLocations] = useState<string>("");
    const [selectedStudentEnglishLocations, setSelectedStudentEnglishLocations] = useState<string[]>([]);
    const [value, setValue] = React.useState<DateRange<Date>>([null, null]);
    const [info, setInfo] = useState<any>();
    const [registerInfo, setRegisterInfo] = useState<any>();
    const [finalResult, setFinalResult] = useState<any>();
    const [postData, setPostData] = useState<any>([]);
    const [discount, setDiscount] = useState<number>(0);
    const [appliedDiscount, setAppliedDiscount] = useState<number>(0);

    const [modalOpen, setModalOpen] = useState<boolean>(false);

    useEffect(() => {

        if(!props.open) {
            setAppliedDiscount(0);
            setDiscount(0);
        }

    }, [props.open]);

    const handleClose = () => {
        setModalOpen(false);
    }


    const submit = async () => {

        try {

            console.log(postData);

            setLoading(true);

            const result: any = await postFetch("/dashboard/payments/registergood", {
                data: postData
            });

            console.log(result);

            setLoading(false);

            if (result.message === "success") {

                const duplicateUserIds = result.duplicateUserIds;
                const errUserIds = result.errUserIds;

                const duplicateUserInfos: any = [];
                const errUserInfos: any = [];

                props.selectedStudentList.forEach((student: any) => {
                    if (duplicateUserIds.includes(student.id)) {
                        duplicateUserInfos.push(student);
                    }
                    if (errUserIds.includes(student.id)) {
                        errUserInfos.push(student);
                    }
                })

                props.setDuplicateUserInfos(duplicateUserInfos);
                props.setErrUserInfos(errUserInfos);

                props.setModalOpen4(true);

                props.handleClose();

                props.setUpdate(Math.random());
            }




        } catch (e) {
            alert("에러가 발생했습니다.");
            console.log(e);
        }

    }

    useEffect(() => {
        if (props.open) {
            const info: Record<string, number> = {};

            props.selectedStudentList.forEach((student: any) => {
                const location =
                    student.location && student.location.trim() !== ""
                        ? student.location
                        : "지점없음";

                info[location] = (info[location] || 0) + 1;
            });

            const englishLocations: any[] = [];

            for (const loc in info) {
                console.log(loc);
                const englishLocation = koreanLocationToEnglish(loc);
                englishLocations.push(englishLocation);
            }
            setSelectedStudentEnglishLocations(englishLocations);

            console.log(englishLocations);

            console.log(info);
            setInfo(info);

            const locationsString = Object.entries(info)
                .map(([location, count]) => `${location} : ${count}명`)
                .join(" / ");

            console.log(locationsString);

            setSelectedStudentsLocations(locationsString);
        }
    }, [props.open, props.selectedStudentList]);

    useEffect(() => {
        if (!props.open) {
            setSelectedStudentsLocations("");
            setValue([null, null]);
            setFinalResult(undefined);
            setPostData([]);
            setRegisterInfo(undefined);
            setInfo(undefined);
            setLoading(false);
        }
    }, [props.open]);

    const formatKoreanDate = (date: Date) => {
        const days = ["일요일", "월요일", "화요일", "수요일", "목요일", "금요일", "토요일"];

        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        const dayOfWeek = days[date.getDay()];

        return `${year}년 ${month}월 ${day}일(${dayOfWeek})`;
    };

    const makePostData = (users: any[], registerInfo: any, startDate: Date, endDate: Date) => {

        const postData: any[] = [];

        startDate.setHours(0, 0, 0, 0);
        endDate.setHours(23, 59, 59, 999);

        const startDateTime = startDate.getTime();
        const endDateTime = endDate.getTime();

        const alreadyHaveUserInfos: any[] = [];
        const afterLastDateUserInfos: any[] = [];

        users.forEach((user: any) => {

            if (user.unpaidOrderItem) {
                alreadyHaveUserInfos.push(user);
                return;
            }

            const location = user.location;

            if (!location || location.trim() === "") {
                return;
            }

            const englishLocation = koreanLocationToEnglish(location);

            if (!englishLocation || !(englishLocation in registerInfo)) {
                return;
            }

            const fee = registerInfo[englishLocation];

            if (!fee) {
                return;
            }

            if (user.lastCome && user.firstCome) {

                const firstComeTime = new Date(user.firstCome).getTime();

                const lastDate = new Date(user.lastCome);
                lastDate.setHours(23, 59, 59, 999);
                const lastDateTime = lastDate.getTime();

                if (lastDateTime > firstComeTime && lastDateTime < endDateTime) {
                    afterLastDateUserInfos.push(user);
                    return;
                } 
            }

            const userId = user.id;

            const oneData: any = {
                userId: userId,
                price: fee,
                startDateTime: startDateTime,
                endDateTime: endDateTime,
            }
            postData.push(oneData);
        });

        props.setAlreadyHaveUserInfos(alreadyHaveUserInfos);
        props.setAfterLastDateUserInfos(afterLastDateUserInfos);

        console.log(postData);
        setPostData(postData);

    }

    useEffect(() => {

        if (!value[0] || !value[1]) {
            return;
        }

        const result = calcRegisterFeeByLocation({
            registerPayInfo: props.registerPayInfo,
            selectedRange: [value[0], value[1]],
            appliedDiscount
        })

        console.log(result);
        setRegisterInfo(result.result);
        makePostData(props.selectedStudentList, result.result, value[0], value[1]);

    }, [value[0], value[1], appliedDiscount]);

    useEffect(() => {

        if (!registerInfo || selectedStudentEnglishLocations.length === 0) {
            return;
        }

        const result = makeGroupedFeeLines({
            result: registerInfo,
            englishLocation: selectedStudentEnglishLocations,
            appliedDiscount,
            englishLocationToKorean,
        });

        console.log(result);

        setFinalResult(result);

    }, [registerInfo, selectedStudentEnglishLocations, appliedDiscount]);

    useEffect(() => {

        if (!registerInfo) {
            return;
        }

        console.log(props.selectedStudentList);

    }, [registerInfo]);



    return (
        <Modal
            open={props.open}
            onClose={props.handleClose}
        >
            <ModalDialog>
                <div style={{
                    width: "620px",
                    overflowY: "auto",
                }}>
                    <div style={{
                        fontFamily: "Apple_B",
                        fontSize: "20px",
                        marginBottom: "18px"
                    }}>
                        상품 추가하기
                    </div>
                    <div>
                        <div style={{
                            fontFamily: "Apple_SB",
                            marginBottom: "10px",
                            fontSize: "17px"
                        }}>
                            선택된 학생 리스트
                        </div>
                        <div>
                            {selectedStudentsLocations}
                        </div>
                    </div>
                    <div style={{
                        marginTop: "24px"
                    }}>
                        <div style={{
                            fontFamily: "Apple_SB",
                            marginBottom: "10px",
                            fontSize: "17px"
                        }}>
                            등록 날짜 설정
                        </div>
                        <div>
                            <LocalizationProvider locale={koLocale} dateAdapter={AdapterDateFns}>
                                <StaticDateRangePicker
                                    value={value}
                                    onChange={(value) => {
                                        console.log(value);
                                        setValue(value);
                                    }}
                                    displayStaticWrapperAs="desktop"
                                    renderInput={(startProps: any, endProps: any) => (
                                        <React.Fragment>
                                            {/* <TextField {...startProps} /> */}
                                            <Box sx={{ mx: 2 }}> to </Box>
                                            {/* <TextField {...endProps} /> */}
                                        </React.Fragment>
                                    )}
                                />
                            </LocalizationProvider>
                        </div>
                    </div>
                    {
                        (value[0] && value[1]) ?
                            <>
                                <div style={{
                                    marginTop: "24px"
                                }}>
                                    <div style={{
                                        fontFamily: "Apple_SB",
                                        marginBottom: "10px",
                                        fontSize: "17px"
                                    }}>
                                        등록 예정 기간
                                    </div>
                                    <div>
                                        {formatKoreanDate(value[0])}
                                        {" ~ "}
                                        {formatKoreanDate(value[1])}
                                    </div>
                                </div>
                                <div style={{
                                    marginTop: "24px"
                                }}>
                                    <div style={{
                                        fontFamily: "Apple_SB",
                                        marginBottom: "10px",
                                        fontSize: "17px",
                                        display: "flex",
                                        alignItems: "center"
                                    }}>
                                        등록 예정 비용
                                        <span style={{
                                            display: "inline-flex", alignItems: "center"
                                        }}
                                        onClick={() => {
                                            setModalOpen(true);
                                        }}
                                        >
                                            <Edit fontSize="small" style={{ marginLeft: "8px", cursor: "pointer" }} />
                                        </span>
                                    </div>
                                    <div>
                                        {finalResult && finalResult.map((line: any, index: number) => (
                                            <div key={index} style={{ marginBottom: "8px" }}>
                                                {line}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </>
                            :
                            ""
                    }

                    <div style={{
                        marginTop: "32px"
                    }}>
                        <Button
                            fullWidth
                            variant="solid"
                            color="primary"
                            onClick={submit}
                            disabled={loading || !postData || postData.length === 0}
                            loading={loading}
                            size="lg"
                        >
                            상품 추가하기
                        </Button>
                    </div>
                </div>

                <Modal
                    open={modalOpen}
                    onClose={handleClose}
                >
                    <ModalDialog>
                        <div style={{
                            width: "300px"
                        }}>
                            <div style={{
                                fontFamily: "Apple_SB",
                                fontSize: "20px",
                                marginBottom: "12px"
                            }}>
                                할인률 설정
                            </div>
                            <div>
                                <Input
                                    fullWidth
                                    type="number"
                                    value={discount}
                                    onChange={(e) => {
                                        setDiscount(+e.target.value);
                                    }}
                                    endDecorator={<span>%</span>}
                                />
                            </div>
                            <div style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                marginTop: "24px"
                            }}>
                                <Button
                                    variant="solid"
                                    onClick={() => {
                                        setAppliedDiscount(discount);
                                        setModalOpen(false);
                                    }}
                                >
                                    적용시키기
                                </Button>
                            </div>
                        </div>
                    </ModalDialog>
                </Modal>


            </ModalDialog>
        </Modal>
    )
}

export default AddGoodModal;